import * as React from "react";
import type { SVGProps } from "react";
const SvgIconDoorman = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.32.82C6.07 1.07 4.3 2.79 4.02 5c-.23 1.8.56 3.6 2.06 4.62 1.62 1.1 3.75 1.13 5.4.05 1.99-1.31 2.72-3.87 1.74-6.05-.29-.63-.76-1.25-1.32-1.71-.65-.55-1.5-.93-2.34-1.06C9.27.81 8.58.8 8.32.82m.1 1.72-.25.04c-.54.1-1.08.4-1.5.8q-.72.68-.91 1.64c-.06.28-.07.83-.03 1.1.07.37.23.82.4 1.12.39.63 1.04 1.14 1.74 1.36.62.2 1.34.2 1.93-.01 1.1-.38 1.91-1.32 2.1-2.45.03-.26.04-.72 0-.96-.2-1.34-1.25-2.4-2.57-2.62-.2-.04-.8-.05-.92-.02m-.04 9.41c-2.86.15-5.44 1.84-6.73 4.42-.31.6-.55 1.3-.69 1.97-.13.64-.15.89-.15 1.8v.83l.07.16q.16.3.46.43l.14.05h9.04q.46-.1.66-.49c.06-.12.06-.16.06-.37 0-.22 0-.25-.06-.37-.08-.15-.25-.32-.38-.39l-.21-.07c-.1-.02-1.25-.02-4.1-.02H2.52v-.19c0-.24.06-.73.12-1.03.5-2.38 2.3-4.24 4.64-4.83.56-.15.84-.18 1.66-.18.85 0 .85 0 1.08-.21.27-.25.36-.62.23-.94-.09-.24-.3-.44-.54-.5-.2-.07-.8-.1-1.33-.07m5.01 0c-.2.03-.34.07-.51.15-.36.18-.67.5-.82.87-.12.27-.12.33-.12 1.81 0 1.46.01 1.68.11 2.26.47 2.75 2.37 5.04 4.99 6.03.43.16.55.17.88.07 1.48-.48 2.94-1.58 3.88-2.93.73-1.06 1.16-2.17 1.35-3.53.06-.42.08-3.13.02-3.41-.11-.6-.57-1.1-1.16-1.27l-.18-.06h-4.14zm.27 3.03c.01 1.4.02 1.47.14 2.04.39 1.85 1.67 3.45 3.42 4.26.16.08.32.14.35.14.08 0 .49-.19.8-.36q.71-.4 1.33-1.02c.84-.83 1.42-1.92 1.66-3.08.1-.53.12-.73.12-2.05v-1.25h-7.83z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconDoorman;
